import { useLayoutEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { selectScene } from 'src/app/redux/slice/sceneSlice';
import './Reference.scss';
import ScrollControls from '../../MobileControls/MobileControls';

// DESKTOP
const lg = window.matchMedia('(min-width: 978px)');

export const Reference = ({ data, allowScroll, blockScroll, logo }) => {
  const logos = require.context('../../../../assets/logos');
  const dispatch = useDispatch();
  const isBackExecute = useRef(false);

  const listenScrollEvent = () => {
    if (window.scrollY == 0 && !isBackExecute.current && lg.matches) {
      window.scrollTo(0, 10);
    }
    if (window.scrollY > 0 && !isBackExecute.current && lg.matches) {
      isBackExecute.current = true;
    }
    if (window.scrollY == 0 && isBackExecute.current && lg.matches) {
      blockScroll();
      setTimeout(() => {
        isBackExecute.current = false;
        dispatch(selectScene('12'));
      }, 200);
    }
  };

  useLayoutEffect(() => {
    isBackExecute.current = false;
    allowScroll();
    window.scrollTo(0, 10);
    window.addEventListener('scroll', listenScrollEvent);
    return () => {
      window.removeEventListener('scroll', listenScrollEvent);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="container">
      <div className="references">
        <div className="references-items">
          <div className="references-items-left">
            {data?.items?.map((item, index) =>
              index < data.items.length / 2 ? (
                <a
                  key={`REFER${index + 1}`}
                  href={item?.url}
                  className={item?.type === 'WEB' ? 'btn-web' : 'btn-pdf'}
                  target="_blank"
                  rel="noreferrer"
                >
                  {item?.title}
                </a>
              ) : null
            )}
          </div>
          <div className="references-items-right">
            {data?.items?.map((item, index) =>
              index > data.items.length / 2 ? (
                <a
                  key={`REFER${index + 1}`}
                  href={item?.url}
                  className={item?.type === 'WEB' ? 'btn-web' : 'btn-pdf'}
                  target="_blank"
                  rel="noreferrer"
                >
                  {item?.title}
                </a>
              ) : null
            )}
          </div>
        </div>
        <div className="references-logo">
          <a href={logo?.dir}>
            <img
              className=""
              width="421px"
              height={'auto'}
              data-depth={'0.18'}
              src={logos(logo?.url)}
              alt={logo?.alt}
            />
          </a>
        </div>
        <div className="references-disclaimer">
          <p>{data?.disclaimer}</p>
        </div>
        <div className="references-credits">
          <div className="references-credits-left">
            <p className="references-credits-title">
              {data?.creditsLeft?.title}
            </p>
            <div
              dangerouslySetInnerHTML={{
                __html: data?.creditsLeft?.description,
              }}
            ></div>

            <a
              href={data?.creditsLeft?.redirect?.url}
              target="_blank"
              rel="noreferrer"
            >
              {data?.creditsLeft?.redirect?.text}
            </a>
          </div>
          <div className="references-credits-right">
            <p className="references-credits-title">
              {data?.creditsRight?.title}
            </p>
            <div
              dangerouslySetInnerHTML={{
                __html: data?.creditsRight?.description,
              }}
            ></div>
            <a
              href={data?.creditsRight?.redirect?.url}
              target="_blank"
              rel="noreferrer"
            >
              {data?.creditsRight?.redirect?.text}
            </a>
          </div>
        </div>
        <div className="references-copyright">
          <p>{data?.creditsRight?.copyright}</p>
        </div>
      </div>
      <ScrollControls prev={'12'} />
    </div>
  );
};
